import { gql } from '@apollo/client'

export const IMPACT_DASHBOARD_ACADEMY_ACTIVITY = gql`
  query ImpactDashboardAcademyActivity($nonprofitOrgId: Int!) {
    impactDashboardAcademyActivity(nonprofitOrgId: $nonprofitOrgId) {
      userFullName
      userId
      userStatus
      resource {
        courseId
        id
        nonprofitTopic
        title
        type
      }
    }
  }
`
